import React, { useState, useEffect, useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Grid } from "@material-ui/core";
import clsx from 'clsx';
import * as appSelector from '../../state/app/selectors';
import MenuRightChats from './../MenuRight/MenuRightChats';
import Api from "../../state/Api";
import io from 'socket.io-client';
import ConversationLive from "../ChatsDashboard/Conversation/ConversationLive";
import Contadores from "./Contadores";

const drawerWidth = 500;

const useStyles = makeStyles((theme, largeScreen) => ({
    
    root: {
      display: 'flex',
    },
    containerStyles : {
      marginRight : '57px',
       transition: theme.transitions.create('margin', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen,
       }),
    },
    containerStylesShift: {
      marginRight:  '300px' 
    },
    containerStylesShiftBig: {
      marginRight: '500px'
    },
    leftContainer: {
      position: 'relative',
      width: '300px',
      overflow: "auto"
    },
    leftContainerBig: {
      position: 'relative',
      flex: 1,
      overflow: "auto"
    },
    listItemPrimaryText:{
      color: '#000',
      fontSize:'1.6em',
      paddingLeft: 10,
      fontWeight: 'bold'
    },
    listItemSecondaryText:{
      color: '#333',
      fontSize:'1.1em',
      paddingLeft: 10
    },
    sendIcon: {
      fontSize: 24
    },
    EmptyF: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
    },
    rightContainer: {
      flex : 1,
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 65px)",
      border: theme.palette.borders,
      overflow: 'hidden'
    },
    rightfloatedDiv: {
      position : 'fixed',
      width : '50px',
      width: '50px',
      height: '50px',
      position: 'fixed',
      right: '82px',
      top: '94px'
    },
    sendButton: {
      padding: 15,
      margin: 10
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    iframe: {
      height : '500px',
      width : '100%'
    },
    iframeBig : {
      height: '660px',
      width: '100%'
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      // justifyContent: 'flex-start',
    },
  }
))


const LiveShopping = (props) => {
    const resizeSize = 1500;
    const [isLargeScreen, setLargeScreen] = useState(window.innerWidth > resizeSize);
    const [message, setMessage] = useState('');
    const [connected, setConnected] = useState(false);
    const [viewersCount, setViewersCount] = useState(0);
    const [conversationCount, setConversationCount] = useState(0);
    const [reactionCount, setReactionCount] = useState(0);
    const classes = useStyles(useTheme(), isLargeScreen);
    const dispatch = useDispatch();
    const myPlaybackUrl = useSelector(appSelector.getCurrentStream());
    console.log(myPlaybackUrl, 'myPlaybackUrl')
    console.log(isLargeScreen, 'isLargeScreen')
    const [conversation, setConversation] = React.useState([]);
    const contactListRef = useRef() ;
    const contactListSuperRef = useRef();
    const menu = useSelector(appSelector.getChatsMenuState());
    const [socket, setSocket ] = useState(null)

    const handleGuardoDatos = () => {
        if (props.super) {
            contactListSuperRef.current.refreshData();
        } else {
            contactListRef.current.refreshData();
        }

    }
   // Replace with your server URL and port

    useEffect(() => {
      /*const socket = io('https://live.tevecompras.com/live', {
        transports: ['polling', 'websocket'],
        path: '/api/socket.io',
        reconnection: true
      }); */
      const socket = io('https://live.tevecompras.com/live', {
        query: { user: 'omni-dashboard' },
        transports: ['websocket'],
        path: '/api/socket.io',
        reconnection: true
      })
      setSocket(socket)

        //socket.connect()
        socket.on('connect', () => {
          console.log('connected to live SOcket >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
        });

        socket.on('chat:message', (data) => {

        });

     
        socket.on('reaction:heart', (data) => {
          setReactionCount(reactionCount + 1)
        });

        socket.on('chat:newMessage', (data) => {
            setConversationCount(conversationCount + 1)
            setConversation((conversation) => [...conversation, data]);
        });
        socket.on('viewer:count', (data) => {
          setViewersCount(data)
        });

        socket.on('disconnect', () => {
            console.log('Disconnected from /my-namespace');
            setConnected(false);
        });

        // Clean up the socket connection on component unmount
        return () => {
            socket.disconnect();
        };
    }, []);
  

    return(
        <div style={{ position: 'relative' }}>
            <Grid container className={classes.root}>
                <Grid container className={clsx(classes.containerStyles, {
                    [classes.containerStylesShift]: menu.isOpen && !isLargeScreen,
                    [classes.containerStylesShiftBig]: menu.isOpen && isLargeScreen,
                })} >
                    <Grid item className={
                        clsx({ [classes.leftContainer]: !isLargeScreen, 
                        [classes.leftContainerBig]: isLargeScreen })} 
                        style={{ overflow: 'hidden', height: 'calc(100vh - 65px)' }}>
                        <iframe className={clsx({
                            [classes.iframe]: menu.isOpen,
                            [classes.iframeBig]: !menu.isOpen
                          })} src={'https://omni.tevecompras.com/videoJs.html?url=' + myPlaybackUrl } frameborder="0"></iframe>
                        <Contadores reactionCount={reactionCount} viewersCount={viewersCount} conversationCount={conversationCount} />
                    </Grid>
                    <Grid item className={classes.rightContainer}   >
                        <ConversationLive conversation={conversation} socket={socket} />
                    </Grid>
                    {/* <Grid item zeroMinWidth className={classes.heightAdjust} xs={statsWidth} lg={4}  > */}
                </Grid>
            </Grid>
            <MenuRightChats isLargeScreen={isLargeScreen} liveShopping={true}  />
        </div>
    )

}

export default LiveShopping;